import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

interface CategoryFormProps {
  onSubmit: (data: { name: string }) => void;
  onCancel: () => void;
}

const CategoryForm = ({ onSubmit, onCancel }: CategoryFormProps) => {
  const [name, setName] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({ name });
  };

  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onCancel();
      }
    };

    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [onCancel]);

  return (
    <motion.form
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="w-full max-w-lg rounded-lg bg-white p-6 shadow-lg"
      onSubmit={handleSubmit}
      onClick={(event) => event.stopPropagation()}
    >
      <div className="space-y-6">
        <div className="flex items-center justify-between gap-3 border-b pb-2">
          <h3 className="text-lg font-semibold">Nouvelle catégorie</h3>
          <button
            type="button"
            onClick={onCancel}
            aria-label="Fermer la fenêtre catégorie"
            className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-gray-100 text-2xl leading-none text-gray-700 transition-colors hover:bg-gray-200"
          >
            ×
          </button>
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Nom de la catégorie
          </label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:border-neon-orange focus:ring-2 focus:ring-neon-orange/20"
            required
            placeholder="ex: Marketing & Acquisition"
          />
        </div>

        <div className="flex justify-end gap-4 pt-6 border-t">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors"
          >
            Annuler
          </button>
          <button
            type="submit"
            className="px-4 py-2 bg-neon-orange text-white rounded-lg hover:bg-[#FF4500] transition-colors"
          >
            Créer la catégorie
          </button>
        </div>
      </div>
    </motion.form>
  );
};

export default CategoryForm;
